<script lang="ts" setup>
import ProblemPresentationCard from '../ProblemPresentation/ProblemPresentationCard.vue';

defineProps<{
  imageNumber: InstanceType<
    typeof ProblemPresentationCard
  >['$props']['imageNumber'];
}>();
</script>

<template>
  <ProblemPresentationCard :image-number="imageNumber">
    <template #titleText>
      <span :class="$style['card__text--accent']">結婚を迎えるにあたって、</span
      >今から何ができるか知りたい
    </template>
    <template #detail>
      理想的な結婚を迎えるために、具体的にどのような対策を取れば良いのか、今からやるべき具体的な備え方を知りたいです。
    </template>
  </ProblemPresentationCard>
</template>

<style lang="scss" module>
.card {
  &__text {
    &--accent {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
